'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @fileoverview 字符串相关
 * @author kirkzheng
 */

/**
 * 清除两边的空格
 */
var trim = exports.trim = function trim() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return str.replace(/^\s*/, '').replace(/\s*$/, '');
};

exports.default = {
  trim: trim
};